// @flow

import popularSearchPages from './popular-search-pages'

export default popularSearchPages
